import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import I18n from '../i18n';
import Button from '../button';

const DefaultButton = props => {
  const {children, ...rest} = props;
  return (
    <Button variant="link" {...rest}>
      {children}
    </Button>
  );
};

DefaultButton.propTypes = {
  children: PropTypes.node,
};

// This component was derived from:
// https://github.com/tannerlinsley/react-table/issues/500#issuecomment-367072028
export default class ReactTablePagination extends Component {
  constructor(props) {
    super();

    this.getSafePage = this.getSafePage.bind(this);
    this.changePage = this.changePage.bind(this);
    this.applyPage = this.applyPage.bind(this);

    this.updateCurrentRows(props);

    this.state = {
      page: props.page,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({page: nextProps.page});

    this.updateCurrentRows(nextProps);
  }

  updateCurrentRows(props) {
    if (
      typeof props.data !== 'undefined' &&
      typeof props.page !== 'undefined' &&
      typeof props.pageSize !== 'undefined'
    ) {
      this.rowCount = props.sortedData.length;
      this.rowMin = props.page * props.pageSize + 1;
      this.rowMax = Math.min((props.page + 1) * props.pageSize, this.rowCount);
    }
  }

  getSafePage(page) {
    if (isNaN(page)) {
      page = this.props.page;
    }
    return Math.min(Math.max(page, 0), this.props.pages - 1);
  }

  changePage(page) {
    page = this.getSafePage(page);
    this.setState({page});
    if (this.props.page !== page) {
      this.props.onPageChange(page);
    }

    this.updateCurrentRows(page);
  }

  applyPage(e) {
    if (e) {
      e.preventDefault();
    }
    const page = this.state.page;
    this.changePage(page === '' ? this.props.page : page);
  }

  render() {
    const {
      // Computed
      pages,
      // Props
      page,
      showPageSizeOptions,
      pageSizeOptions,
      pageSize,
      showPageJump,
      canPrevious,
      canNext,
      onPageSizeChange,
      className,
      PreviousComponent = DefaultButton,
      NextComponent = DefaultButton,
    } = this.props;

    return (
      <div className={classnames(className, '-pagination')} style={this.props.style}>
        {typeof this.rowCount !== 'undefined' ? (
          <span className="-rowInfo">
            <I18n t="datatable.sInfo" opts={{start: this.rowMin, end: this.rowMax, total: this.rowCount}} />
          </span>
        ) : (
          ''
        )}

        <div className="page-controls">
          <PreviousComponent
            onClick={() => {
              if (!canPrevious) return;
              this.changePage(page - 1);
            }}
            disabled={!canPrevious}
          >
            <I18n t="datatable.oPaginate.sPrevious" />
          </PreviousComponent>

          <span className="-pageInfo">
            {this.props.pageText}{' '}
            {showPageJump ? (
              <div className="-pageJump">
                <input
                  type={this.state.page === '' ? 'text' : 'number'}
                  onChange={e => {
                    const val = e.target.value;
                    const page = val - 1;
                    if (val === '') {
                      return this.setState({page: val});
                    }
                    this.setState({page: this.getSafePage(page)});
                  }}
                  value={this.state.page === '' ? '' : this.state.page + 1}
                  onBlur={this.applyPage}
                  onKeyPress={e => {
                    if (e.which === 13 || e.keyCode === 13) {
                      this.applyPage();
                    }
                  }}
                />
              </div>
            ) : (
              <span className="-currentPage">{page + 1}</span>
            )}{' '}
            {this.props.ofText} <span className="-totalPages">{pages || 1}</span>
          </span>

          {showPageSizeOptions && (
            <span className="select-wrap -pageSizeOptions">
              <select onChange={e => onPageSizeChange(Number(e.target.value))} value={pageSize}>
                {pageSizeOptions.map((option, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <option key={i} value={option}>
                    {option} {this.props.rowsText}
                  </option>
                ))}
              </select>
            </span>
          )}

          <NextComponent
            onClick={() => {
              if (!canNext) return;
              this.changePage(page + 1);
            }}
            disabled={!canNext}
          >
            <I18n t="datatable.oPaginate.sNext" />
          </NextComponent>
        </div>
      </div>
    );
  }
}

ReactTablePagination.propTypes = {
  page: PropTypes.number,
  pages: PropTypes.number,
  pageText: PropTypes.string,
  rowsText: PropTypes.string,
  ofText: PropTypes.string,
  style: PropTypes.object,
  showPageSizeOptions: PropTypes.bool,
  pageSizeOptions: PropTypes.array,
  pageSize: PropTypes.number,
  showPageJump: PropTypes.bool,
  canPrevious: PropTypes.bool,
  canNext: PropTypes.bool,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  className: PropTypes.string,
  PreviousComponent: PropTypes.func,
  NextComponent: PropTypes.func,
};
